import { exportExcel } from "@api/stores/salesInvoiceReport/exportExcel/api";
import { exportPDF } from "@api/stores/salesInvoiceReport/exportPDF/api";
import { exportSinglePDF } from "@api/stores/salesInvoiceReport/exportSinglePDF/api";
import { stats } from "@api/stores/salesInvoiceReport/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  ISalesInvoiceReportGetAllParams,
  ISalesInvoiceReportResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISalesInvoiceReportResponse>>,
  IPathBaseParam,
  IPaginationParams & ISalesInvoiceReportGetAllParams
>("stores.salesInvoiceReport");

export const salesInvoiceReport = {
  ...getAllApis,
  stats,
  exportPDF,
  exportExcel,
  exportSinglePDF,
};
